export default __webpack_public_path__ + "assets/icons/iconDown.0a870127.svg";